<div class="guide-layer" *ngIf="active">
  <!-- 透明点击拦截层：挡住用户对底部真实页面的操作 -->
  <div class="guide-mask"></div>
  <!-- 镂空高亮框：超大外阴影做暗色遮罩 -->
  <div class="guide-hole" [ngStyle]="holeStyle"></div>
  <!-- 讲解气泡 -->
  <div
    class="guide-box"
    [ngStyle]="boxStyle"
    [ngClass]="{ show: boxShow, centered: boxCentered }"
  >
    <h3>{{ title }}</h3>
    <p [innerHTML]="text"></p>
    <div class="guide-foot">
      <span class="guide-step">{{ stepLabel }}</span>
      <button type="button" class="guide-btn" (click)="next()">
        {{ btn }}
      </button>
    </div>
  </div>
</div>
